import { computed, defineComponent, reactive, ref } from "vue";
import { Form } from "ant-design-vue";
import { mergeAjaxDataToForm } from "@/utils";
import { formRules } from "./form-btn.constant";
import { UnitService } from "../../unit.service";
import { UnitReq } from "../../unit.interface";
import { notifyEmitter } from "@/utils/emitter";

export default defineComponent({
  name: "FormBtn",
  props: {
    id: {
      type: String,
      default: "",
    },
    showAddUnit: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    refresh: null,
  },
  setup(props, { attrs, slots, emit }) {
    const visible = ref(false);
    const isEdit = computed(() => !!props.id);

    const formRef = reactive(new UnitReq());
    const ruleRef = reactive(formRules);
    const { resetFields, validate, validateInfos } = Form.useForm(formRef, ruleRef);

    const { run: runDetail, loading: detailLoading } = UnitService.useDetailApi();
    const { run: runCreate, loading: createLoading } = UnitService.useCreateApi();
    const { run: runEdit, loading: editLoading } = UnitService.useEditApi();

    const showCreateModal = async () => {
      visible.value = true;
    };
    notifyEmitter.on("showAddUnit", (e) => {
      visible.value = true;
      formRef.name = e.length > 10?e.slice(0,10):e;
    });
    const showEditModal = async () => {
      visible.value = true;
      if (isEdit.value) {
        const res = await runDetail(props.id);
        if (res.respCode === "0000") {
          mergeAjaxDataToForm(res.data, formRef);
        }
      }
    };

    const closeModal = () => {
      resetFields();
      visible.value = false;
    };

    const submit = async () => {
      await validate();
      const res = isEdit.value ? await runEdit(props.id, formRef) : await runCreate(formRef);
      if (res.respCode === "0000") {
        closeModal();
        emit("refresh", null);
        notifyEmitter.emit("addUnitBack", (res.data as any)?.id);
        notifyEmitter.emit("addUnit", "true");
      }
    };

    return {
      visible,
      isEdit,
      formRef,
      validateInfos,
      detailLoading,
      createLoading,
      editLoading,
      showCreateModal,
      showEditModal,
      submit,
      closeModal,
    };
  },
});
